import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type {
  SubtractGeometriesResponse,
  TractGeometriesResponse,
} from './types';

export const [subtractGeometriesAtom, subtractGeometriesLoadableAtom] =
  atomWithLoadable(async () => {
    const response = await request.get<SubtractGeometriesResponse>(
      '/admin/duplicate_geometries/subtracts'
    );
    if ('error' in response) {
      throw new Error(response.error);
    }
    return response;
  });

// Filter state for tract group pagination and sorting
export const tractGroupFilterAtom = atom<{
  page: number;
  perPage: number;
  sortColumn: string | null;
  sortDirection: 'asc' | 'desc';
}>({
  page: 1,
  perPage: 100,
  sortColumn: null,
  sortDirection: 'asc',
});

// Base async atom that re-fetches when filter changes
const tractGeometriesBaseAtom = atom(async (get) => {
  const filters = get(tractGroupFilterAtom);

  const params = new URLSearchParams();
  params.append('page', filters.page.toString());
  params.append('per_page', filters.perPage.toString());
  if (filters.sortColumn) {
    params.append('sort_column', filters.sortColumn);
    params.append('sort_direction', filters.sortDirection);
  }

  const response = await request.get<TractGeometriesResponse>(
    `/admin/duplicate_geometries/tracts?${params.toString()}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const tractGeometriesLoadableAtom = loadable(tractGeometriesBaseAtom);
